import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const generalPersonalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings-general',
	path: '/jira/settings/personal/general',
};
